import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { API_URL } from 'common/constants/sm-constants';
import { InternshipDetailsGridMetaModel } from 'common/models/page-models/Student Internship List/Intership Details/internship-details-meta.model';
import { InternshipDetailsGridDataService } from 'common/services/data-services/admin/Intership-List/internship-deatils-data.service';
import { InternshipDetailsListListingModel } from 'common/models/page-models/Student Internship List/Intership Details/internship-details-model';
import { InternshipDetailsListModel } from 'common/models/page-models/Student Internship List/Intership Details/internship-details-data.model';


@Injectable({
    providedIn: 'root'
})
export class InternshipDetailsGridWidgetService extends GridWidgetService<InternshipDetailsListModel,InternshipDetailsListListingModel> {
    constructor(protected override ds: InternshipDetailsGridDataService, protected systemService: SystemService) {
        super(ds);
        // console.log("called")
    }
    getMetaModel(): MetaModel {
        const meta = new InternshipDetailsGridMetaModel().getMetaModel();
        return meta;
    }

    postCertificateStatus(payload) {
        this.ds.postDataToCustomEndPoint(payload, null, environment.apiUrl + API_URL.VerifyUploadedStudentCertificate).then((data) => {
            this.systemService.showSuccess(data['header'].msg)
        })
    }

    async getFilterOptions(filterMetaModel: any) {
        const urlList = [{ url: environment.apiUrl + API_URL.getBatchList, payload: '' }, 
                { url: environment.apiUrl + API_URL.branchList, payload: '' }, 
                { url: environment.apiUrl + API_URL.stateList, payload: '' },
                ];
        await this.ds.apiCallFromMultipleAPIforGrid(urlList).then((data) => {
            
            filterMetaModel.properties.selectedBatch.options = data[0].details;
            filterMetaModel.properties.selectedBranch.options = data[1].details;
            filterMetaModel.properties.selectedState.options = data[2].details;
        })
    }
    
    askMentorFeedback(data: any) {
        // console.log("DATA", data);
        
        const payload = {
            internshipCode: data.internshipCode
        }
        this.ds.postDataToCustomEndPoint(payload, null, environment.apiUrl + API_URL.askMentorFeedback).then((data) => {
            // console.log(data);
            
            this.systemService.showSuccess("Mentor Feedback Success")
        })
    }

    terminateInternshipStudents(data: any) {
        // console.log("DATA", data);
        
        // const payload = {
        //     id: data.internshipCode
        // }
        // this.ds.postDataToCustomEndPoint(payload, null, environment.apiUrl + API_URL.TerminateInternshipStudent).then((data) => {
        //     console.log(data);
            
        //     this.systemService.showSuccess("Students Terminated")
        // })
    }

    // deleteInternshipData(id: any[]): Promise<any> {
    //     return new Promise<any>((resolve, reject) => {
    //         this.deleteInternship.postData({ id: id }).then(() => {
    //             resolve('data deleted successfully')
    //         })
    //             .catch((error) => {
    //             })
    //     })
    // }

}